var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.sections),function(s){return _c('div',{staticClass:"info-section alt-color-rev"},[_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(s)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }